export enum FieldType {
  TEXT = 'text',
  TEXTAREA = 'textarea',
  EMAIL = 'email',
  PASSWORD = 'password',
  PHONE = 'phone',
  PHONE_OTP = 'phone_otp',
  DATE = 'date',
  SELECT = 'select',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  FILE_UPLOAD = 'file-upload',
  OTP = 'otp',
  LINK = 'link',
  CONSENT_SELECT = 'consent_select',
  PLACES_AUTOCOMPLETE = 'places_autocomplete',
}

export interface FormOption {
  id: number;
  title: string;
  answer: string | number | boolean;
}

// export interface FormFieldConsent {
//   title: string;
//   subtitle?: string;
//   content: string;
//   accept_label?: string;
//   acceptance_id?: string;
//   url?: string;
// }

export interface FormField {
  id: number;
  title: string;
  type: FieldType | string;
  system_identifire: string;
  section_type: string;
  is_display: number;
  position: number;
  is_display_section?: number;
  isOptional?: boolean;
  hint?: string;
  value?: any;
  options?: FormOption[];
  parent_question_id?: number;
  parent_option_id?: number;
  accept?: string;
  rows?: number;
  subtitle?: string;
  content?: string;
  // consent?: FormFieldConsent;
  country?: string;
  disabled?: boolean;
  help?: string;
  showHideFlag?: boolean;
  error?: string;
  [key: string]: any;
}

export interface FormSection {
  section_type: string;
  section_name: string;
  section_info?: string;
  position: number;
  is_display_section?: number;
  questions: FormField[];
}

// Field type categories for rendering
export const FIELD_CATEGORIES = {
  TEXT_FIELDS: [
    FieldType.TEXT,
    FieldType.EMAIL,
    FieldType.PASSWORD,
    FieldType.TEXTAREA,
  ],
  SELECTION_FIELDS: [FieldType.SELECT, FieldType.RADIO, FieldType.CHECKBOX],
  PHONE_FIELDS: [FieldType.PHONE, FieldType.PHONE_OTP],
  OTP_FIELDS: [FieldType.OTP],
  SPECIAL_FIELDS: [FieldType.FILE_UPLOAD, FieldType.DATE, FieldType.LINK, FieldType.CONSENT_SELECT, FieldType.PLACES_AUTOCOMPLETE],
};

export const FIELD_CONFIG: Record<string, { fullWidth?: boolean; width?: string; defaultValue?: any }> = {
  [FieldType.TEXT]: { width: '28vw' },
  [FieldType.TEXTAREA]: { fullWidth: true, width: '100%' },
  [FieldType.EMAIL]: { width: '28vw' },
  [FieldType.PASSWORD]: { width: '28vw' },
  [FieldType.PHONE]: { width: '28vw' },
  [FieldType.PHONE_OTP]: { fullWidth: true, width: '100%' },
  [FieldType.DATE]: { width: '28vw' },
  [FieldType.SELECT]: { width: '28vw' },
  [FieldType.RADIO]: { fullWidth: true, width: '70vw' },
  [FieldType.CHECKBOX]: { fullWidth: true, width: '100%' },
  [FieldType.FILE_UPLOAD]: { fullWidth: true, width: '100%' },
  [FieldType.OTP]: { fullWidth: true, width: '100%' },
  [FieldType.CONSENT_SELECT]: { width: '28vw' },
  [FieldType.PLACES_AUTOCOMPLETE]: { fullWidth: true, width: '100%' },
};

// Validation patterns
export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
  SSN: /^\d{3}-\d{2}-\d{4}$/,
  URL: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
};

export const getFieldWidth = (fieldType: string): string => {
  return FIELD_CONFIG[fieldType]?.width || '28vw';
};

export const isFullWidthField = (fieldType: string): boolean => {
  return FIELD_CONFIG[fieldType]?.fullWidth || false;
};

export const isSelectionField = (fieldType: string): boolean => {
  return FIELD_CATEGORIES.SELECTION_FIELDS.includes(fieldType as FieldType);
};

export const isPhoneField = (fieldType: string): boolean => {
  return FIELD_CATEGORIES.PHONE_FIELDS.includes(fieldType as FieldType);
};

export const isTextField = (fieldType: string): boolean => {
  return FIELD_CATEGORIES.TEXT_FIELDS.includes(fieldType as FieldType);
};
